import 'react-toastify/dist/ReactToastify.css';
import './assets/style/global.css';

import {BrowserRouter} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';

import {UpdateAvailableBanner} from './components/UpdateAvailableBanner';
import {AppRatesProvider} from './context/AppRatesProvider';
import {CountryListProvider} from './context/CountryListProvider';
import {ThemeProvider} from './context/ThemeProvider';
import {AuthProvider} from './hooks/AuthProvider';
import {useNewVersionAvailable} from './hooks/useNewVersionAvailable';
import Routes from './Routes';

function App() {
  const updateAvailable = useNewVersionAvailable();

  return (
    <AuthProvider>
      <ThemeProvider>
        <AppRatesProvider>
          <CountryListProvider>
            <BrowserRouter>
              <Routes />
              <ToastContainer
                position="top-right"
                autoClose={3000}
                closeOnClick
                hideProgressBar
                theme="colored"
              />
              {updateAvailable && (
                <UpdateAvailableBanner
                  onUpdate={() => window.location.reload()}
                />
              )}
            </BrowserRouter>
          </CountryListProvider>
        </AppRatesProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
